import { Route, Routes } from 'react-router-dom'
import RoomsPage from './Page'
import { useSession } from 'components/Providers';
import NoAccess from 'components/NoAccess';

export default function Rooms() {
  const { permissions } = useSession();
  if (!permissions['setting.room']) return <NoAccess />

  return (
    <Routes>
      <Route path="/" element={<RoomsPage />}/>
      <Route path="/:id" element={<RoomsPage />}/>
    </Routes>
  )
}
